module.exports = __webpack_public_path__ + "img/img_songhaoli.f3f030ed.png";